/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Tags_Manager_Remove_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to delete tag set: {error}" |
*
* @param {Tags_Manager_Remove_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_remove_failed_toast = /** @type {((inputs: Tags_Manager_Remove_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Remove_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de la suppression de l'ensemble de tags : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Tag-Set konnte nicht gelöscht werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile eliminare il set di tag: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось удалить набор тегов: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo eliminar el conjunto de etiquetas: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`删除标签集失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`タグセットの削除に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`टैग सेट ${i?.error} को हटाने में विफल रहा`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao excluir o conjunto de tags: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to delete tag set: ${i?.error}`)
});